import {UseMutationOptions, useMutation, useQueryClient} from '@tanstack/react-query'
import {errorHandler, raise} from '@utilities/helpers.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpDeleteAssignment} from '@features/admin/http/admin.http'
import {useAuthStore} from '@features/user/store/store'

type deleteAssignmentParams = {
    reason_id: number
    cancellation_type: 'soft_cancellation' | 'hard_cancellation'
    notes?: string
    assignmentId: number
}
export const useDeleteAssignment = (
    options?: Omit<UseMutationOptions<unknown, unknown, deleteAssignmentParams>, 'mutationFn' | 'mutationKey'>
) => {
    const queryClient = useQueryClient()
    const adminAccessToken = useAuthStore(state => state.adminAccessToken) ?? raise('adminAccessToken is nullish')
    return useMutation<unknown, unknown, deleteAssignmentParams>({
        mutationFn: ({assignmentId, reason_id, cancellation_type, notes}) =>
            httpDeleteAssignment({
                params: {
                    reason_id: reason_id,
                    cancellation_type: cancellation_type,
                    notes: notes
                },
                urlParams: {assignmentId, adminAccessToken}
            }),
        onError: errorHandler,
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HOME_TABLE]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
